import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import BreadCrumb from './index.js';
import '../../style/core/base/font-awesome.min.scss';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "breadcrumb-面包屑"
    }}>{`BreadCrumb 面包屑`}</h1>
    <p>{`使用于页面导航的面包屑组件`}</p>
    <h2 {...{
      "id": "基本使用"
    }}>{`基本使用`}</h2>
    <p>{`显示多级页面标题`}</p>
    <Playground __position={0} __code={'<div style={{ marginTop: \'10px\', marginBottom: \'30px\', marginLeft: \'10px\' }}>\n  <BreadCrumb>\n    <BreadCrumb.Item>首页</BreadCrumb.Item>\n    <BreadCrumb.Item>次页</BreadCrumb.Item>\n    <BreadCrumb.Item active>尾页</BreadCrumb.Item>\n  </BreadCrumb>\n</div>'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      BreadCrumb,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
  <div style={{
        'marginTop': '10px',
        'marginBottom': '30px',
        'marginLeft': '10px'
      }}>
    <BreadCrumb mdxType="BreadCrumb">
      <BreadCrumb.Item>首页</BreadCrumb.Item>
      <BreadCrumb.Item>次页</BreadCrumb.Item>
      <BreadCrumb.Item active>尾页</BreadCrumb.Item>
    </BreadCrumb>
  </div>
    </Playground>
    <h2 {...{
      "id": "属性"
    }}>{`属性`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`属性名`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`名称`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`类型`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`默认值`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`seperator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`分割符`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`/`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`active`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`当前所在导航项`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`false`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      